module.exports = "/assets/data/eb5849bc30e3ba6b03a85cb7bdd536b3-CW1.data.json";